"use strict";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { track_event } from "./views/common/tracker";
import assert from "@brillout/assert";
export { loadScript };
var LOAD_TIMEOUT = 5;

function loadScript(_x, _x2) {
  return _loadScript.apply(this, arguments);
}

function _loadScript() {
  _loadScript = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(scriptUrl, scriptName) {
    var alreadyResolved, hasTimedOut, resolve, promise, scriptEl;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            assert(scriptUrl.startsWith("https://"));
            alreadyResolved = false;
            hasTimedOut = false;
            promise = new Promise(function (r) {
              return resolve = r;
            });
            scriptEl = document.createElement("script");
            scriptEl.src = scriptUrl;
            scriptEl.async = true;

            scriptEl.onload = function () {
              resolve(true);
              trackLoadState(true, true, hasTimedOut, scriptUrl, scriptName);
              alreadyResolved = true;
            };

            scriptEl.onerror = function () {
              resolve(false);
              trackLoadState(false, true, hasTimedOut, scriptUrl, scriptName);
              alreadyResolved = true;
            };

            document.getElementsByTagName("head")[0].appendChild(scriptEl);
            setTimeout(function () {
              if (alreadyResolved) {
                return;
              }

              resolve(false);
              hasTimedOut = true;
              trackLoadState(false, false, hasTimedOut, scriptUrl, scriptName);
            }, LOAD_TIMEOUT * 1000);
            return _context.abrupt("return", promise);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadScript.apply(this, arguments);
}

function trackLoadState(success, resolved, hasTimedOut, scriptUrl, scriptName) {
  var loadState;

  if (!resolved) {
    assert(!success);
    assert(hasTimedOut);
    loadState = "timeout";
  } else {
    if (success) {
      loadState = "loaded";
    } else {
      loadState = "failed";
    }

    if (hasTimedOut) {
      loadState += " [after-timeout]";
    }
  }

  var name = "[".concat(scriptName, "] ").concat(scriptUrl, " ").concat(loadState);
  track_event({
    name: name
  });
}